module.exports = __webpack_public_path__ + "img/icon1.0adfec54.png";